import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'config/i18n'; // Initialize i18n
import App from 'app/App';
import { store } from 'config/redux/store';
import { InstagramConnectionProvider } from 'contexts/InstagramConnectionContext';
import { ThemeProvider } from 'contexts/ThemeContext';
import reportWebVitals from 'config/reportWebVitals';
import 'styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
        <ThemeProvider>
          <InstagramConnectionProvider>
            <App />
          </InstagramConnectionProvider>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </Provider>
);

reportWebVitals();